import { ADD_ONS_EDITOR_TOUR } from './addOnsEditorTour';
import type { TourScript } from './tourRunner';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- the Vuex store and the locale strings are plain JavaScript: they carry no types
type Untyped = any;

export type TourDefinition = {
    id: string;
    /** Part of the storage key: bumping it offers a reworked tour again. */
    version: number;
    /** The tour's own section under the `tours` locale block. */
    stringsKey: string;
    isAvailable(getters: Untyped): boolean;
    /** When the reader is in the situation the tour teaches: the offer fires the first time this holds. */
    offerWhen(state: Untyped, getters: Untyped): boolean;
    script(getters: Untyped, strings: Untyped): TourScript;
};

export type TourFlag = 'answered' | 'completed';
type TourKey = TourFlag | 'ignored';

export const TOURS: Record<string, TourDefinition> = {
    [ADD_ONS_EDITOR_TOUR.id]: ADD_ONS_EDITOR_TOUR,
};

export function tourFlagKey(tour: Pick<TourDefinition, 'id' | 'version'>, flag: TourKey): string {
    return `featureTour:${tour.id}:v${tour.version}:${flag}`;
}

// A WebView with storage blocked answers as if nothing was written: offering
// once more is the cheaper mistake.
export function hasTourFlag(tour: Pick<TourDefinition, 'id' | 'version'>, flag: TourFlag): boolean {
    try {
        return localStorage.getItem(tourFlagKey(tour, flag)) === 'true';
    } catch {
        return false;
    }
}

export function markTourFlag(tour: Pick<TourDefinition, 'id' | 'version'>, flag: TourFlag): void {
    try {
        localStorage.setItem(tourFlagKey(tour, flag), 'true');
    } catch {
        // Nothing to do: the tour is offered again next time.
    }
}

/** How many times the offer went unanswered on this device. */
export function tourIgnoredCount(tour: Pick<TourDefinition, 'id' | 'version'>): number {
    try {
        return Number(localStorage.getItem(tourFlagKey(tour, 'ignored'))) || 0;
    } catch {
        return 0;
    }
}

export function countTourIgnored(tour: Pick<TourDefinition, 'id' | 'version'>): void {
    try {
        localStorage.setItem(tourFlagKey(tour, 'ignored'), String(tourIgnoredCount(tour) + 1));
    } catch {
        // Nothing to do: an unanswered offer that leaves no trace is offered again.
    }
}
